export const SET_CONTEXT = 'SET_CONTEXT'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/connecteddevices/types.js